import { render, staticRenderFns } from "./diaDictionary.vue?vue&type=template&id=1c3d4554"
import script from "./diaDictionary.vue?vue&type=script&lang=js"
export * from "./diaDictionary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports